import {
	MODULE_NAME,
	DOWNLOAD_ALL,
	SET_DOWNLOAD_ALL
} from './downloadFile-mutation-types';

import { TOAST_MESSAGES_PUSH } from '@/store/modules/mutation-types';

import { ApiService as api } from '@/services/axiosHelper';
import buildRoute from '@/composables/build-route';

export default {
	strict: process.env.NODE_ENV !== 'production',
	name: MODULE_NAME,
	namespaced: true,
	state: {
		[SET_DOWNLOAD_ALL]: []
	},
	mutations: {
		[SET_DOWNLOAD_ALL](state, data) {
			state[DOWNLOAD_ALL] = data;
		}
	},
	actions: {
		async setDownloadAll({ commit, dispatch }, parameters) {
			const { logId, level } = parameters || {};
			try {
				const results = await api.get(
					buildRoute(`logs/globaltransactions/${logId}/${level}/downloadall`),
					{ responseType: 'blob' }
				);
				commit(SET_DOWNLOAD_ALL, results);
				return results;
			} catch (error) {
				let messageObj = {
					statusCode: 404,
					message: 'There are no files to download'
				};
				dispatch(TOAST_MESSAGES_PUSH, messageObj, {
					root: true
				});
			}
		}
	},
	getters: {
		[DOWNLOAD_ALL]: state => state[DOWNLOAD_ALL]
	}
};
